<template>
    <div class="recruit-review">
      <el-table
        size="mini"
        :data="reviewTableData"
        :stripe="true"
        border
        style="width: 100%">
<!--        <el-table-column-->
<!--          type="selection"-->
<!--          width="40">-->
<!--        </el-table-column>-->
        <el-table-column
          fixed
          prop="createDate"
          label="申请时间"
          width="auto">
          <template slot-scope="scope">
            <span>{{scope.row.createDate | dateFormat("YYYY-MM-DD HH:mm:ss")}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="user"
          label="申请人"
          width="120">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="申请人联系方式"
          width="120">
        </el-table-column>
        <el-table-column
          prop="company"
          label="所属公司"
          :show-overflow-tooltip="true"
          width="auto">
        </el-table-column>
        <el-table-column
          prop="companyPic"
          label="公司营业执照"
          width="120">
          <template slot-scope="scope">
            <span style="cursor: pointer;color: #409eff"
                  title="点击查看并审核该公司的营业执照"
                  @click="showCompanyPic(scope.row.companyPic)">
              <img :src="scope.row.companyPic" height="20px" />
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="state"
          label="状态"
          width="auto">
          <template slot-scope="scope">
            <span v-if="scope.row.state === '待审核'" style="color: #409EFF">{{scope.row.state}}</span>
            <span v-if="scope.row.state === '已拒绝'" style="color: #F56C6C">{{scope.row.state}}</span>
            <span v-if="scope.row.state === '已通过'" style="color: #67C23A">{{scope.row.state}}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="auto">
          <template slot-scope="scope">
            <el-button @click="passReview(scope.row)" type="text" size="small" v-if="scope.row.state === '待审核'">通过</el-button>
            <el-button type="text" size="small" @click="refuseReview(scope.row)" v-if="scope.row.state === '待审核'">拒绝</el-button>
            <span v-if="scope.row.state !== '待审核'">--</span>
          </template>
        </el-table-column>
      </el-table>
      <div style="padding: 10px 0; text-align: right">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.pageNum"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total">
        </el-pagination>
      </div>

      <el-dialog :visible.sync="picDialogVisible" :width="'600px'">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
    </div>
</template>

<script>
export default {
  name: 'RecruiterReview',
  data () {
    return {
      reviewTableData: [],
      picDialogVisible: false,
      dialogImageUrl: '',
      page: {
        pageNum: 1,
        pageSize: 20,
        total: 0
      }
    }
  },
  methods: {
    initData () {
      this.reviewTableData = [
        {
          createDate: new Date().getTime(),
          user: '陈实',
          phone: '13202290257',
          company: '上海易宝软件有限公司深圳分公司',
          companyPic: this.$store.get('user').image,
          state: '待审核'
        },
        {
          createDate: new Date().getTime(),
          user: '陈实',
          phone: '13202290257',
          company: '上海易宝软件有限公司深圳分公司',
          companyPic: this.$store.get('user').image,
          state: '已拒绝'
        },
        {
          createDate: new Date().getTime(),
          user: '陈实',
          phone: '13202290257',
          company: '上海易宝软件有限公司深圳分公司',
          companyPic: this.$store.get('user').image,
          state: '已通过'
        }
      ]
    },
    handleCurrentChange (e) {
      this.page.pageNum = e
      this.initData()
    },
    handleSizeChange (e) {
      this.page.pageSize = e
      this.initData()
    },
    showCompanyPic (pic) {
      this.picDialogVisible = true
      this.dialogImageUrl = pic
    },
    passReview (row) {

    },
    refuseReview (row) {

    }
  },
  created () {
    this.initData()
  }
}
</script>

<style scoped>
.recruit-review {
  width: 1200px;
  margin: auto;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/RecruiterReview/RecruiterReview.vue